import { getLevelCount } from 'a/cityPlanner/redux/selectors/curriculumSelectors';
import { getAvailableLevels } from 'a/cityPlanner/content/curriculum';
import { REDUX_ACTIONS, GAME_ID } from '../../data/constants';

const initState = {
  isOnboarded: false,
  highestLevelEarned: 0,
};

const screenReducer = (state = initState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.COMPLETE_ONBOARDING:
      return {
        ...state,
        isOnboarded: true,
      };

    case REDUX_ACTIONS.ROUND_END: {
      const { levelIndex, isSuccess, isEarlyExit } = payload;
      if (isSuccess && !isEarlyExit) {
        const levelArray = getAvailableLevels();
        const indexInLevelArray = levelArray.indexOf(levelIndex);
        const nextIndexInLevelArray = Math.min(indexInLevelArray + 1, getLevelCount() - 1);
        const highestLevelEarned = levelArray[nextIndexInLevelArray];
        return {
          ...state,
          highestLevelEarned,
        };
      }
      return state;
    }

    default:
      return state;
  }
};

export default screenReducer;
